/**
 * Модальные окна: типы поиска и описания словарей
 */

function openSearchTypeModal() {
  var modal = document.getElementById('search-type-modal');
  var content = modal.querySelector('.search-type-modal-content');
  
  // Добавляем класс для анимации
  modal.classList.add('active');
  document.body.style.overflow = 'hidden';
  
  // Фокус на контент для доступности
  if (content) {
    content.setAttribute('tabindex', '-1');
    content.focus();
  }
}

function closeSearchTypeModal() {
  var modal = document.getElementById('search-type-modal');
  var content = modal.querySelector('.search-type-modal-content');
  
  // Убираем фокус перед закрытием
  if (content) {
    content.removeAttribute('tabindex');
    content.blur();
  }
  
  // Закрываем с анимацией
  modal.classList.remove('active');
  
  // Восстанавливаем скролл после завершения анимации
  setTimeout(function() {
    if (!modal.classList.contains('active')) {
      document.body.style.overflow = '';
    }
  }, 300);
}

function openDictModal(element) {
  var dictName = element.getAttribute('data-dict-name');
  // Используем data-dict-code если есть, иначе fallback на data-dict-name
  var dictCode = element.getAttribute('data-dict-code') || dictName;
  
  if (!dictCode || dictCode.trim() === '') {
    return; // Если кода нет, не показываем модалку
  }
  
  var modal = document.getElementById('dict-modal');
  var content = modal.querySelector('.dict-modal-content');
  var titleElement = document.getElementById('dict-modal-title');
  var textElement = document.getElementById('dict-modal-text');
  
  // Показываем модалку сразу с индикатором загрузки
  titleElement.textContent = dictName;
  textElement.innerHTML = '<div style="text-align: center; padding: 20px; color: #999;">Загрузка...</div>';
  
  modal.classList.add('active');
  document.body.style.overflow = 'hidden';
  
  // Фокус на контент для доступности
  if (content) {
    content.setAttribute('tabindex', '-1');
    content.focus();
  }
  
  // Загружаем описание из базы данных
  fetch('/api?dict=' + encodeURIComponent(dictCode))
    .then(function(response) {
      if (!response.ok) {
        throw new Error('Failed to load dictionary description');
      }
      return response.json();
    })
    .then(function(data) {
      if (data.success && data.desc_short) {
        // Используем dict_ui если есть, иначе dict_code
        var displayName = data.dict_ui || data.dict_code || dictName;
        titleElement.textContent = displayName;
        textElement.innerHTML = data.desc_short.replace(/<b-r><\/?b-r>/g, '<br>');
      } else {
        // Если описания нет, показываем сообщение
        titleElement.textContent = dictName;
        textElement.innerHTML = '<div style="text-align: center; padding: 20px; color: #999;">Описание словаря отсутствует</div>';
      }
    })
    .catch(function(error) {
      console.error('Error loading dictionary description:', error);
      titleElement.textContent = dictName;
      textElement.innerHTML = '<div style="text-align: center; padding: 20px; color: #999;">Ошибка загрузки описания</div>';
    });
}

function closeDictModal() {
  var modal = document.getElementById('dict-modal');
  var content = modal.querySelector('.dict-modal-content');
  
  // Убираем фокус перед закрытием
  if (content) {
    content.removeAttribute('tabindex');
    content.blur();
  }
  
  // Закрываем с анимацией
  modal.classList.remove('active');
  
  // Восстанавливаем скролл после завершения анимации
  setTimeout(function() {
    if (!modal.classList.contains('active')) {
      document.body.style.overflow = '';
    }
  }, 300);
}

// Функции для модального окна настроек
function openSearchHistoryModal() {
  // Название функции сохранено для совместимости, но теперь она открывает только настройки
  var modal = document.getElementById('search-history-modal');
  if (!modal) return;
  
  var content = modal.querySelector('.search-history-modal-content');
  
  modal.classList.add('active');
  document.body.style.overflow = 'hidden';

  if (window.THEME_UI && window.THEME_UI.initModalControls) {
    window.THEME_UI.initModalControls();
  }
  
  if (content) {
    content.setAttribute('tabindex', '-1');
    content.focus();
  }
}

function closeSearchHistoryModal() {
  var modal = document.getElementById('search-history-modal');
  if (!modal) {
    return;
  }
  
  var content = modal.querySelector('.search-history-modal-content');
  
  // Убираем фокус перед закрытием
  if (content) {
    content.removeAttribute('tabindex');
    content.blur();
  }
  
  // Закрываем с анимацией
  modal.classList.remove('active');
  
  // Восстанавливаем скролл после завершения анимации
  setTimeout(function() {
    if (!modal.classList.contains('active')) {
      document.body.style.overflow = '';
    }
  }, 300);
}

// Функция для открытия модалки (теперь по умолчанию открывается таб настроек)
function openSearchSettingsModal() {
  if (typeof openSearchHistoryModal === 'function') {
    openSearchHistoryModal();
  }
}

// Закрытие по ESC
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    closeSearchTypeModal();
    closeDictModal();
    closeSearchHistoryModal();
  }
});

// Функция для управления табами в модальном окне
function initModalTabs() {
  var tabs = document.querySelectorAll('.search-modal-tab');
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var tabName = this.getAttribute('data-tab');
      
      // Переключаем активный таб
      tabs.forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
      
      // Переключаем контент
      var contents = document.querySelectorAll('.search-modal-tab-content');
      contents.forEach(function(c) { c.classList.remove('active'); });
      
      var activeContent = document.getElementById('tab-' + tabName);
      if (activeContent) {
        activeContent.classList.add('active');
      }

      // Если переключились на оформление, инициализируем контролы (на случай если они еще не)
      if (tabName === 'appearance' && window.THEME_UI && window.THEME_UI.initModalControls) {
        window.THEME_UI.initModalControls();
      }
    });
  });
}

// Инициализация при загрузке
document.addEventListener('DOMContentLoaded', function() {
  initModalTabs();
});

// Экспортируем глобально
window.SEARCH_MODAL = {
  openSearchTypeModal: openSearchTypeModal,
  closeSearchTypeModal: closeSearchTypeModal,
  openDictModal: openDictModal,
  closeDictModal: closeDictModal,
  openSearchHistoryModal: openSearchHistoryModal,
  closeSearchHistoryModal: closeSearchHistoryModal,
  openSearchSettingsModal: openSearchSettingsModal
};

// Глобальные функции для совместимости
window.openSearchTypeModal = openSearchTypeModal;
window.closeSearchTypeModal = closeSearchTypeModal;
window.openSearchHistoryModal = openSearchHistoryModal;
window.closeSearchHistoryModal = closeSearchHistoryModal;
window.openSearchSettingsModal = openSearchSettingsModal;

console.log('[MODAL] Module loaded, window.SEARCH_MODAL exported:', !!window.SEARCH_MODAL);
console.log('[MODAL] openSearchHistoryModal available:', !!(window.SEARCH_MODAL && window.SEARCH_MODAL.openSearchHistoryModal));
console.log('[MODAL] window.openSearchHistoryModal available:', typeof window.openSearchHistoryModal);

